module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1140.fe1f56b2.png";